import { supabase } from '@/lib/supabase/client'
import { Job, NewJob } from '@/types/admin'

export const JobsService = {
  async getAll() {
    const { data, error } = await supabase
      .from('jobs')
      .select('*')
      .order('created_at', { ascending: false })

    if (error) throw error
    return data as Job[]
  },

  async create(job: NewJob) {
    console.log('DB insert started for job:', job.school_name)

    // Ensure payload is pure JSON
    const payload = JSON.parse(JSON.stringify(job))

    const { data, error } = await supabase
      .from('jobs')
      .insert(payload)
      .select()
      .single()

    if (error) {
      console.error('DB insert failed:', error)
      throw error
    }

    console.log('DB insert success')
    return data as Job
  },

  async update(id: string, updates: Partial<Job>) {
    const { data, error } = await supabase
      .from('jobs')
      .update(updates as any)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data as Job
  },

  async delete(id: string) {
    const { error } = await supabase.from('jobs').delete().eq('id', id)

    if (error) throw error
  },
}
